import axios from 'axios';
import { GET } from '../../utils/axios-interceptor';

export const fetchStatusTimeline = (payload: { referenceId: string; auditLogType: string }, baseURL?: string, endpoint?: string) => {
    const apiEndpoint = endpoint || API_ENDPOINTS.GET_AUDIT_LOGS;

    return axios({
        url: apiEndpoint,
        method: GET,
        params: payload,
        ...(baseURL && { baseURL }),
    });
};

const API_ENDPOINTS = {
    GET_AUDIT_LOGS: 'account/getAuditLogs',
    GET_UNIFIER_AUDIT_LOGS: 'unifier/getAuditLogs',
};
